import { API } from '@resclick/compass';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { CrsAction, CrsForm } from '@resclick/crs-ui';

@Component
export default class ModalTabMixin<N extends keyof API, A extends keyof API[N]> extends Vue {
  @Prop({ type: String }) id?: string;
  loading = false;
  form!: CrsForm<N, A>;

  promptToSave = false;
  promptAction!: () => void;

  get mode() {
    return this.id ? 'update' : 'create';
  }

  created(this: any) {
    if (this.mode === 'update' && typeof this.getForm === 'function') {
      this.loading = true;
      this.getForm()
        .then(({ data }: { data: any }) => {
          this.form.setFields(data);
        })
        .finally(() => (this.loading = false));
    }
  }

  /* Check and prompt for save data */
  checkUnsaved(action: () => void) {
    if (this.form && this.form.hasChanges && this.form.hasChanges()) {
      this.promptToSave = true;
      this.promptAction = action;
    } else {
      if (typeof action === 'function') action();
    }
  }

  onPrompt(event: string, params: any) {
    if (event === 'submit') {
      this.onSubmit(params).then(() => this.promptAction());
    } else if (event === 'discard') {
      this.form.reset();
      this.promptAction();
    }
  }

  async onSubmit(
    params: CrsAction<API[N][A]> extends { params: any }
      ? { [K in CrsAction<API[N][A]>['params'][number]]: string }
      : undefined,
    options?: { lang?: string },
  ) {
    this.loading = true;
    if ((this as any).preSubmit) {
      await (this as any).preSubmit();
    }
    return this.form
      .submit({ params, lang: options?.lang })
      .then((res: any) => this.$emit('update-data', res.data))
      .finally(() => (this.loading = false));
  }
}
